/**
 * Created by Ding on 12/04/2017.
 * Initialed by louyunchuan on 17/3/28.
 */

import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import querystring from 'querystring';
import { Table } from 'antd';
import Moment from 'moment';

import CandidateForm from './CandidatesForm';
import { ajaxGet, ajaxPost } from '../../utils/ajax';


export default class Candidates extends Component {

    static propTypes = {
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
    };

    state = {
        statuses: [],
        candidates: [],
        total: 0,
    };

    componentDidMount() {
        this.getStatus();
        this.getCandidates(querystring.parse(this.props.location.search ? this.props.location.search.slice(1) : ''));
    }

    componentWillReceiveProps(newProps) {
        this.getCandidates(querystring.parse(newProps.location.search ? newProps.location.search.slice(1) : ''));
    }

    onSearch = (params) => { 
        const modifiedParams = Object.assign({}, params);
        if (params.createTime && params.createTime.length > 0) {
            modifiedParams.createTimeStart = Moment(params.createTime[0]).format('YYYY-MM-DD 00:00:00');
            modifiedParams.createTimeEnd = Moment(params.createTime[1]).format('YYYY-MM-DD 23:59:59');
            delete modifiedParams.createTime;
        }
        const newParams = {};
        Object.keys(modifiedParams)
            .filter(item => modifiedParams[item] !== undefined
            && modifiedParams[item] !== null && modifiedParams[item] !== '')
            .forEach((item) => {
                newParams[item] = modifiedParams[item];
            });
        this.props.history.push(`${this.props.location.pathname}${Object.keys(newParams).length > 0 ?
            `?${querystring.stringify(newParams)}` : ''}`);
    };

    onPageChange = (pageNum) => {
        const params = Object.assign({}, querystring.parse(this.props.location.search ?
            this.props.location.search.slice(1) : ''), { pageNum });
        this.onSearch(params);
    };

    getStatus = () => {
        ajaxGet('/recruit/api/hunter/getHunterEnumMap', {}, (rawData) => {
            this.setState({
                statuses: rawData.data.PhaseType,
            });
        });
    };

    getCandidates = (params) => {
        const newParams = Object.assign({
            pageSize: 10,
            pageNum: 1,
        }, params);
        ajaxPost('/recruit/api/hunter/searchApplyInfoV2', newParams, (rawData) => {
            this.setState({
                candidates: rawData.data.items,
                total: rawData.data.total,
                pageNum: rawData.data.page,
            });
        });
    };

    handleTableChange = (pagination, filters, sorter) => {
        const sortParams = {};
        if (sorter.order === 'descend') {
            sortParams.order = 'desc';
        } else if (sorter.order === 'ascend') {
            sortParams.order = 'asc';
        }
        if (sorter.columnKey === 'name') {
            sortParams.field = 2;
        } else if (sorter.columnKey === 'createTime') {
            sortParams.field = 1;
        }
        const params = Object.assign({}, querystring.parse(this.props.location.search ?
            this.props.location.search.slice(1) : ''), sortParams, { pageNum: pagination.current });
        this.onSearch(params);
    };

    handleFilterSubmit = (params) => {
        const newParams = Object.assign({}, params);
        const query = querystring.parse(this.props.location.search ? this.props.location.search.slice(1) : '');
        newParams.order = query.order;
        newParams.field = query.field;
        this.onSearch(newParams);
    };

    render() {
        const sortedInfo = {};
        const query = querystring.parse(this.props.location.search ? this.props.location.search.slice(1) : '');
        if (query.field) {
            if (query.field === '1') {
                sortedInfo.columnKey = 'createTime';
            } else if (query.field === '2') {
                sortedInfo.columnKey = 'name';
            }
            if (query.order === 'asc') {
                sortedInfo.order = 'ascend';
            } else if (query.order === 'desc') {
                sortedInfo.order = 'descend';
            }
        }
        const columns = [{
            title: '候选人',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'name' && sortedInfo.order,
            render: (text, record) => (<Link to={`/candidate/${record.id}`}>{text}</Link>),
        }, {
            title: '推荐职位',
            dataIndex: 'jobTitle',
            render: (text, record) => (<Link to={`/position_${record.jdId}/detail`}>{text}</Link>),
        }, {
            title: '推荐状态',
            dataIndex: 'status',
            render: (text) => {
                if (this.state.statuses.length > 0 &&
                this.state.statuses.some(item => item.code === text)) {
                    return this.state.statuses.find(item => item.code === text).desc;
                }
                return '';
            },
        }, {
            title: '淘汰原因',
            dataIndex: 'outReasonDesc',
        }, {
            title: '职位处理人',
            dataIndex: 'recruiterName',
        }, {
            title: '推荐时间',
            dataIndex: 'createTime',
            render: (text) => {
                if (text) {
                    return text.slice(0, 10);
                }
                return '';
            },
            key: 'createTime',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'createTime' && sortedInfo.order,
        }, {
            title: '操作',
            dataIndex: 'noIndex',
            render: (text, record) => (<Link to={`/candidate/${record.id}`}>查看详情</Link>),
        }];

        const paginationConfig = {
            pageSize: 10,
            total: this.state.total,
            showQuickJumper: true,
            current: this.state.pageNum,
            onChange: (page) => {
                this.onPageChange(page);
            },
        };

        return (
            <div>
                <CandidateForm
                    handleSubmit={this.handleFilterSubmit}
                    statuses={this.state.statuses}
                    {...querystring.parse(this.props.location.search ? this.props.location.search.slice(1) : '')}
                />

                <Table
                    className="loose-table-no-checkbox"
                    columns={columns}
                    rowKey={record => record.id}
                    dataSource={this.state.candidates}
                    pagination={paginationConfig}
                    onChange={this.handleTableChange}
                />
            </div>
        );
    }
}
